<template>
    <page>
        <module>
            <view-list ref="view" :work-type="workType" :view-config="saasInfo.viewmanage">
                <template #search>
                    <m-search ref="search" :extend-data="defaultSearchData">
                        <m-search-item label="背贴码">
                            <m-code-batch-input name="produce_unique_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量">
                            </m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="IMEI">
                            <m-code-batch-input name="produce_imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="产品信息">
                            <c-input name="product_info"></c-input>
                        </m-search-item>
                        <m-search-item label="采购人">
                            <c-input name="purchase_user_name"></c-input>
                        </m-search-item>
                        <m-search-item label="验机人">
                            <c-input name="quality_user_name"></c-input>
                        </m-search-item>
                        <m-search-item label="等级">
                            <c-select :options="LEVEL_TYPE" name="level_type"></c-select>
                        </m-search-item>
                        <m-search-item label="创建时间">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>
                <template #operate>
                    <c-button v-if="auth('b_high_stock_age_export')" prepend-icon="tf-export"
                              @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>
                <template #produce_info="{data}">
                    <m-product-info :name="data.produce_info || getProductText(data)" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
                </template>
                <!--等级-->
                <template #level_type="{data}">
                    <c-state tag async dict="LEVEL_TYPE" :value="data.level_type"></c-state>
                </template>
                <!--背贴码主状态-->
                <template #main_state="{data}">
                    <c-state tag async dict="UNIQUE_CODE_MAIN_STATE" :value="data.main_state"></c-state>
                </template>
                <!--背贴码详细状态-->
                <template #state="{data}">
                    <c-state tag async dict="UNIQUE_CODE_STATE" :value="data.state"></c-state>
                </template>
                <!--采购价-->
                <template #purchase_price="{data}">
                    ￥{{data.purchase_price}}
                </template>
                <!--维修费-->
                <template #repair_cost="{data}">
                    ￥{{data.repair_cost}}
                </template>
                <!--是否拆机（拆机商品悬停按背贴码查询拆机订单：下单时间+拆机项明细）-->
                <template #is_dismantle="{data}">
                    <c-tooltip v-if="data.is_dismantle==1" position="bottom" color="white" @mouseenter.native="loadDismantleOrders(data)">
                        <span class="m-dismantle-tag">拆</span>
                        <template #tip>
                            <p v-if="getDismantleState(data).loading" class="m-dismantle-item">正在查询拆机订单...</p>
                            <p v-else-if="getDismantleState(data).error" class="m-dismantle-item">{{getDismantleState(data).error}}</p>
                            <template v-else>
                                <p v-for="(order, index) in getDismantleState(data).orders" :key="index" class="m-dismantle-item">{{formatDismantleDate(order.create_date)}}&nbsp;&nbsp;{{order.items.join('、')}}</p>
                                <p v-if="!getDismantleState(data).orders.length" class="m-dismantle-item">暂无拆机记录</p>
                            </template>
                        </template>
                    </c-tooltip>
                    <span v-else>-</span>
                </template>

                <c-table-column
                        type="button"
                        label="操作"
                        width="150"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_high_stock_age_remark_view')" icon="tf-detail" @click="showRemark(data)">查看备注</c-table-button>
                    </template>
                </c-table-column>
            </view-list>
            <!--查看备注弹窗-->
            <code-remark ref="codeRemark"></code-remark>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import {asyncMapState} from '@/store'
import codeRemark from "@/pages/storage/code_remark.vue";

export default {
    name: 'm_high_stock_age',

    components: {codeRemark},

    computed: {
        ...mapState(['saasInfo','userInfo']),

        ...asyncMapState(['LEVEL_TYPE', 'DISMANTLE_ITEM'])
    },

    data() {
        return {
            defaultSearchData: {
            },
            workType: 24,            //待入库商品列表
            /**是否拆机列悬停拆机订单查询状态：key=背贴码，结果 60s 内复用，避免反复悬停重复请求 */
            dismantleMap: {},
            /**悬停防抖定时器：鼠标快速划过列表时不逐个触发接口 */
            dismantleTimer: null
        }
    },
    beforeDestroy() {
        if (this.dismantleTimer) clearTimeout(this.dismantleTimer);
    },
    methods: {
        /*********获取产品信息文字**********/
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.model_name) parts.push(data.model_name);
            if (data.memory_name) parts.push(data.memory_name);
            if (data.color_name) parts.push(data.color_name);
            return parts.join(' ') || '-';
        },

        /*********悬停是否拆机列：悬停 200ms 才发起查询，结果 60s 内复用，避免鼠标划过列表时批量打接口**********/
        loadDismantleOrders(data) {
            if (data.is_dismantle != 1) return;
            var key = data.produce_unique_code;
            var state = this.dismantleMap[key];
            // 在途请求未返回前不重复发起，避免鼠标移动抖动产生并发查询
            if (state && state.loading) return;
            // 已有结果（含失败结果）的短时缓存：同一行反复悬停不再重复查询
            if (state && (Date.now() - (state.time || 0) < 60000)) return;
            if (this.dismantleTimer) clearTimeout(this.dismantleTimer);
            this.dismantleTimer = setTimeout(function () {
                this.fetchDismantleOrders(key);
            }.bind(this), 200);
        },

        /*********实际发起拆机订单查询（已经过悬停防抖）**********/
        fetchDismantleOrders(key) {
            this.$set(this.dismantleMap, key, {
                loading: true,
                error: '',
                orders: [],
                time: 0
            });
            this.request({
                url: '/offline/sale/order/dismantleOrders',
                data: {
                    produce_code: key
                },
                fail: (code, obj, msg) => {
                    // 悬停查询失败不弹全局提示，错误信息在浮层内展示
                    this.$set(this.dismantleMap, key, {
                        loading: false,
                        error: msg || '拆机订单查询失败',
                        orders: [],
                        time: Date.now()
                    });
                    return false;
                },
                success: result => {
                    // 每笔拆机订单浮层一行：下单时间+拆机项名称列表
                    var orders = ((result && result.orders) || []).map(order => {
                        return {
                            create_date: order.create_date,
                            items: this.formatDismantleItems(order.dismantle_items)
                        };
                    });
                    this.$set(this.dismantleMap, key, {
                        loading: false,
                        error: '',
                        orders: orders,
                        time: Date.now()
                    });
                }
            });
        },

        /*********获取当前行拆机订单浮层状态（查询中/失败/订单列表）**********/
        getDismantleState(data) {
            var state = this.dismantleMap[data.produce_unique_code] || {};
            return {
                loading: !!state.loading,
                error: state.error || '',
                orders: state.orders || []
            };
        },

        /*********解析拆机项并按字典翻译显示名称（存储为字典value数组，与开单页口径一致）**********/
        formatDismantleItems(value) {
            if (!value) return [];
            var list = value;
            if (typeof list == 'string') {
                try {
                    list = JSON.parse(list);
                } catch (e) {
                    return [value];
                }
            }
            if (!Array.isArray(list)) return [];
            var dict = this.DISMANTLE_ITEM || [];
            return list.map(item => {
                // 数组项为字典value或{value,name}对象，统一取value后翻译为字典名称展示
                var val = String(item && item.value ? item.value : item);
                var option = dict.find(dic => String(dic.value) == val);
                return option ? option.name : val;
            }).filter(item => item);
        },

        /*********拆机订单下单时间格式化（设计图展示到日）**********/
        formatDismantleDate(value) {
            if (!value) return '-';
            // 后端返回完整时间字符串，取日期部分展示
            return String(value).slice(0, 10);
        },
        /****展示备注****/
        showRemark(data) {
            this.$refs.codeRemark.open(data);
        }
    }
}
</script>
<style lang="stylus" scoped>
.m-dismantle-tag {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border: 1.5px solid #ed3f14;
    border-radius: 50%;
    color: #ed3f14;
    font-size: 13px;
    font-weight: bold;
}

/* 是否拆机列悬停浮层：每行=下单时间+拆机项明细 */
.m-dismantle-item {
    margin: 0;
    line-height: 20px;
    white-space: nowrap;
}
</style>